export default __webpack_public_path__ + "static/media/GreyEagle.2507dc26.png";